import React from 'react';

// const CDN_DOMAIN = 'https://kia-afonso.b-cdn.net';
//someting wrong with bunny so revering using kia.com for now
const CDN_DOMAIN = 'https://www.kia.com';
const ORIGINAL_DOMAIN = 'kia.com';

interface CDNImageProps {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  quality?: number;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  className?: string;
  style?: React.CSSProperties;
}

const KIAImage: React.FC<CDNImageProps> = ({
  src,
  alt,
  width = '100%',
  height = 0,
  quality = 80,
  sizes,
  loading = 'lazy',
  className,
  style,
}) => {
  const isKiaUrl = (url: string) => url && url.includes(ORIGINAL_DOMAIN);

  const generateSrcSet = (path: string) => {
    const resolutions = [640, 1080, 1920, 2560];
    return resolutions
      .map((res) => `${CDN_DOMAIN}/${path}?width=${res}&q=${quality} ${res}w`)
      .join(', ');
  };

  let finalSrc = src;
  let srcSet: string;

  if (isKiaUrl(src)) {
    const urlParts = new URL(src);
    const path = urlParts.pathname + urlParts.search + urlParts.hash;
    finalSrc = `${CDN_DOMAIN}${path}?w=${width}&quality=${quality}`;
    srcSet = generateSrcSet(path);
  }

  return (
    <img
      src={finalSrc}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      srcSet={srcSet}
      loading={loading}
      className={className}
      style={style}
    />
  );
};

export default KIAImage;
